import { render } from "./CompanyProfileView.vue?vue&type=template&id=2c42b7c0&scoped=true"
import script from "./CompanyProfileView.vue?vue&type=script&lang=js"
export * from "./CompanyProfileView.vue?vue&type=script&lang=js"

import "./CompanyProfileView.vue?vue&type=style&index=0&id=2c42b7c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c42b7c0"]])

export default __exports__